import React, { useEffect, useState } from 'react';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { Add, Close, Folder } from '@mui/icons-material';

const ActividadesOrganismo = ({ data, setDatos, errores }) => {
    const [catalogoActividades, setCatalogoActividades] = useState([]);

    useEffect(() => {
        const fetchGiros = async () => {
            try {
                const response = await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/catalogo_actividades`);
                const result = await response.json();
                setCatalogoActividades(result.data); // Ajusta según la estructura de la respuesta
            } catch (error) {
                console.error('Error al cargar el catálogo de giros:', error);
            }
        };

        fetchGiros();
    }, []);

    const handleAddActividad = () => {
        setDatos({
            target: {
                name: 'actividades',
                value: [
                    ...data.actividades,
                    { giro: '' } // Nueva actividad con campo 'giro' vacío
                ]
            }
        });
    };

    const handleInput = (e) => {
        const imagen = e.target.files[0];
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                setDatos({ target: { name: 'imagenes', value: [...data.imagenes, imagen] } });
            };
            reader.readAsDataURL(imagen);
        }
    };

    const removeImg = (imgUrl) => {
        setDatos({ target: { name: 'imagenes', value: data.imagenes.filter(img => img.dataurl !== imgUrl) } });
    };

    return (
        <div>
            <Typography variant="h5">Actividades Económicas</Typography>
            <Grid container spacing={2}>
                {data.actividades.map((actividad, index) => (
                    <Grid item xs={12} key={index}>
                        <FormControl fullWidth margin="normal" error={errores.includes('giro')}>
                            <InputLabel id={`giro-label-${index}`} required>Giro Económico {index + 1}</InputLabel>
                            <Select
                                labelId={`giro-label-${index}`}
                                label={`Giro Económico ${index + 1}`}
                                name={`giro-${index}`}
                                value={actividad.giro}
                                onChange={(e) => {
                                    const updatedActividades = [...data.actividades];
                                    updatedActividades[index].giro = e.target.value;
                                    setDatos({ target: { name: 'actividades', value: updatedActividades } });
                                }}
                            >
                                {catalogoActividades.map((giro) => (
                                    <MenuItem key={giro.codigo_act} value={giro.codigo_act}>
                                        {giro.nombre_act}
                                    </MenuItem>
                                ))}
                                <MenuItem key="otro" value="otro">Otro</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                ))}
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" onClick={handleAddActividad} startIcon={<Add />}>
                        Agregar Actividad
                    </Button>
                </Grid>
            </Grid>

            <Box sx={{ mt: 3 }}>
                <Typography variant="h6">Fotogalería de Actividades Económicas (Máximo 7 imágenes)</Typography>
                <Stack direction="row" spacing={2} sx={{ mt: 2, mb: 2 }}>
                    {data.imagenes.map((image, idx) => (
                        <Box key={idx} sx={{ position: 'relative' }}>
                            <IconButton sx={{ position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(image.dataurl)}>
                                <Close />
                            </IconButton>
                            <img src={image.dataurl} alt={`imagen-${idx}`} width="150px" />
                        </Box>
                    ))}
                </Stack>
                <Button
                    component="label"
                    variant="contained"
                    startIcon={<Folder />}
                    disabled={data.imagenes.length >= 7}
                >
                    Agregar Imágenes
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleInput}
                        hidden
                    />
                </Button>
            </Box>
        </div>
    );
};

export default ActividadesOrganismo;
